import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {UrlBuilder} from "./url-builder/url.builder";
import {ClientListWithAccess} from "./listclients/clientlistwithaccess";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private urlBuilder: UrlBuilder = new UrlBuilder();

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    req = req.clone({
      setHeaders: {
        'Accept'       : 'application/json',
        'USERDATA'     : 'Bearer ' + this.urlBuilder.GetToken(),
        'SERCOMTARGET' :  this.urlBuilder.GetCurrentClient(),
        'MONITORLIST'  : 'Bearer ' + ClientListWithAccess.GetAccessListByToken()
      },
    });
    return next.handle(req);
  }
}





